import { FUEL_OPTIONS } from 'config/app-config';

export const getFuelValue = ({ gas, electric }) => {
  if (gas && electric) {
    return FUEL_OPTIONS.DUAL;
  } else if (electric) {
    return FUEL_OPTIONS.ELECTRIC;
  } else if (gas) {
    return FUEL_OPTIONS.GAS;
  } else {
    return '';
  }
};
